import styled from 'styled-components'

import { palette } from '../../style/theme'

export const PDPOverlayWrapper = styled.div`
  width: 92%;
  height: 76%;
  position: absolute;
  top: 3vh;
  left: 4%;
  background: ${palette.white};
  border-radius: 10px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  padding: 1.5em;
`
